// extracted by mini-css-extract-plugin
module.exports = {"w1we7d4z":"w1we7d4z","bau7q73":"bau7q73"};